<dbw-investor-viewer-accordion
  anchorId="investor-viewer-commandes-atlas"
  accordionTitle="Commandes"
  [itemsCount]="$safeNavigationMigration(commands()?.length)"
  [loading]="loading()">
  @if (loading()) {
    <dbw-state-card
      appearance="loading"
      [compact]="true">
      <p>Chargement des Commandes en cours.</p>
    </dbw-state-card>
  } @else if (error()) {
    <dbw-state-card
      appearance="error"
      [compact]="true">
      <p>{{ error() }}</p>
    </dbw-state-card>
  } @else if (commands()) {
    @if (commands()!.length === 0) {
      <div class="empty-state">Aucune commande rattachée à cet investisseur.</div>
    } @else {
      <div class="section-stack">
        @for (command of commands(); track command.commandId) {
          <article class="sub-card dbw-card dbw-card--md">
            <header class="entity-header">
              <div>
                <h5>{{ getCommandTitle(command) }}</h5>
                <p>
                  Commande #{{ command.commandId }} • Numéro {{ formatNumber(command.commandNumber) }} • Contrat
                  {{ formatText(command.contractNumber) }}
                </p>
              </div>
              <strong class="entity-value">{{ formatCurrency(command.totalSaleAmount) }}</strong>
            </header>

            <div class="detail-grid">
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">Type</span>
                <strong>{{ formatText(command.commandTypeLabel) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">État</span>
                <strong>{{ formatText(command.commandStateLabel) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">Ordre investisseur</span>
                <strong>{{ formatNumber(command.investorOrder) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">Création</span>
                <strong>{{ formatDate(command.creationDate) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">Réception contrat</span>
                <strong>{{ formatDate(command.contractReceptionDate) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">Date d'effet</span>
                <strong>{{ formatDate(command.effectiveDate) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">Date d'acte</span>
                <strong>{{ formatDate(command.deedDate) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">Annulation</span>
                <strong>{{ formatDate(command.cancellationDate) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--lg">
                <span class="detail-item__label">Base commissionnement</span>
                <strong>{{ formatCurrency(command.commissionBaseAmount) }}</strong>
              </article>
            </div>

            <dbw-investor-viewer-accordion
              accordionTitle="Mouvements"
              level="subtitle"
              [itemsCount]="command.movements.length">
              @if (command.movements.length === 0) {
                <div class="empty-inline">Aucun mouvement rattaché à cette commande.</div>
              } @else {
                <div class="section-stack">
                  @for (movement of command.movements; track movement.movementId) {
                    <article class="mini-block">
                      <header class="entity-header entity-header--compact">
                        <div>
                          <h5>{{ getMovementTitle(movement) }}</h5>
                          <p>
                            Mouvement #{{ movement.movementId }} • État
                            {{ formatText(movement.movementStateLabel) }} • Investisseur
                            {{ formatNumber(movement.investorId) }}
                          </p>
                        </div>
                        <strong class="entity-value">{{ formatCurrency(movement.paymentAmount) }}</strong>
                      </header>

                      <div class="detail-grid">
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Nature</span>
                          <strong>{{ formatText(movement.natureMovementLabel) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Périodicité</span>
                          <strong>{{ formatText(movement.periodicityLabel) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Début</span>
                          <strong>{{ formatDate(movement.startDate) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Fin</span>
                          <strong>{{ formatDate(movement.endDate) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Traitement</span>
                          <strong>{{ formatDate(movement.processingDate) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Date valeur</span>
                          <strong>{{ formatDate(movement.valueDate) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Date d'acte</span>
                          <strong>{{ formatDate(movement.deedDate) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Annulation</span>
                          <strong>{{ formatDate(movement.cancellationDate) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Base commission</span>
                          <strong>{{ formatCurrency(movement.commissionBaseAmount) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Nouveaux frais</span>
                          <strong>{{ formatPercentage(movement.newFees) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Taux frais produit</span>
                          <strong>{{ formatPercentage(movement.productFeeRate) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Frais réels</span>
                          <strong>{{ formatCurrency(movement.realFeeAmount) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Validation comptable</span>
                          <strong>{{ formatDate(movement.accountingValidationDate) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Point valeur stratégique</span>
                          <strong>{{ formatNumber(movement.strategicValuePoint) }}</strong>
                        </article>
                        <article class="detail-item dbw-card dbw-card--lg">
                          <span class="detail-item__label">Correspondant</span>
                          <strong>{{ formatBoolean(movement.hasCorrespondent) }}</strong>
                        </article>
                      </div>
                    </article>
                  }
                </div>
              }
            </dbw-investor-viewer-accordion>
          </article>
        }
      </div>
    }
  } @else {
    <dbw-state-card
      appearance="info"
      [compact]="true">
      <p>Les Commandes ne sont pas encore disponibles.</p>
    </dbw-state-card>
  }
</dbw-investor-viewer-accordion>
